import { useState, useRef } from 'react';
import { Modal, Input, Tag, Space } from 'antd';
import type { InputRef } from 'antd';

interface ConfirmOptions {
    title?: string;
    message?: string;
    okText?: string;
    cancelText?: string;
}

export function useConfirm() {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [okText, setOkText] = useState('');
    const [cancelText, setCancelText] = useState('');

    const [isOpen, setIsOpen] = useState(false);
    const onCloseRef = useRef<null | Function>(null);
    const inputRef = useRef<InputRef>(null);

    const closeAndResolve = (value: boolean) => {
        setIsOpen(false);
        if (onCloseRef.current) {
            onCloseRef.current(value);
            onCloseRef.current = null;
        }
    };

    const handleCancel = () => {
        closeAndResolve(false);
    };

    const handleOk = () => {
        closeAndResolve(true);
    };

    return {
        confirm: async ({
            title = 'Подтверждение',
            okText = 'ОК',
            cancelText = 'Отмена',
            message = 'Вы уверены?',
        }: ConfirmOptions) => {
            setIsOpen(true);
            setTitle(title);
            setMessage(message);
            setOkText(okText);
            setCancelText(cancelText);

            requestAnimationFrame(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                }
            });

            return new Promise<boolean>((resolve) => {
                onCloseRef.current = (value: boolean) => resolve(value);
            });
        },

        confirmModal: (
            <Modal
                title={title}
                open={isOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={okText}
                cancelText={cancelText}
                zIndex={3500}
            >
                {message}
            </Modal>
        ),
    };
}
